import { useParams } from 'react-router-dom';
import { EntityGet } from 'data/firestore/types';
import { Customer } from 'data/firestore/agent/customer/types';
import { useConnectModal } from '@rainbow-modules/hooks';
import useCustomer from 'data/firestore/agent/customer/useOnce';
import { Phonenumber } from 'data/firestore/agent/customer/phonenumber/types';
import ModalBody from './modal';
import { CUSTOMER_CALL_MODAL } from '../../constants';
import { StyledModal } from './styled';

const CustomerCallModal = () => {
    const { agentId = '' } = useParams();
    const connectedModalProps = useConnectModal(CUSTOMER_CALL_MODAL, { title: '' });
    const {
        customer, phoneNumber, onRequestClose, isOpen, ...otherProps
    } = connectedModalProps;

    const customerId = typeof customer === 'string' ? customer : (customer as Customer)?.id as string;
    const shouldFetchCustomer = !!agentId && typeof customer === 'string' && !!customerId;

    const { data: customerInfo, isLoading } = useCustomer(
        agentId,
        customerId,
        {
            disabled: !shouldFetchCustomer,
        },
    );

    const customerData = customerInfo || customer;

    const showOpen = isOpen && !isLoading;

    return (
        <StyledModal
            size="small"
            isOpen={showOpen}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onRequestClose={onRequestClose}
            {...otherProps}
        >
            <ModalBody
                customer={customerData as EntityGet<Customer>}
                phoneNumber={phoneNumber as Phonenumber}
                onRequestClose={onRequestClose as () => void}
            />
        </StyledModal>
    );
};

export default CustomerCallModal;
